import React from 'react'
import PropTypes from 'prop-types'
import { Layout } from '../../components'
import DynamicZone from '../../helpers/dynamicZone'

const Microsite = ({ pageContext }) => {
  // pageContext - Elementos pasados como parametros
  // data - Información obtenida de la query
  
  const { 
    micrositeId, 
    micrositeData,
    navbar,
    footerData
  } = pageContext

  const { body, pageMetadata, scripts } = micrositeData

  return (
    <Layout
      key={`micorsite-${micrositeId}`}
      screenData={micrositeData.navbar.length !== 0 ? micrositeData : navbar}
      pageMetadata={pageMetadata}
      scriptSelect={scripts}
      footerData={footerData}
    >
      <DynamicZone components={body} />
    </Layout>
  )
}

Microsite.propTypes = {
  pageContext: PropTypes.object.isRequired,
}

export default Microsite